import { Injectable } from "@angular/core";
import { InvestigacionDTO } from "@DTOS";
import { DatosModalInvestigacionBasicos, ModalInvestigacionDatosBasicosComponent } from "@shared/components";
import { ModalService } from "@shared/services";
import { InvestigacionesUtils } from "../Investigaciones.utils";

@Injectable({
    providedIn: "root"
})
export class InvestigacionesUtilsImpl implements InvestigacionesUtils {
    constructor(private modalService: ModalService) {}

    public async crearInvestigacionAsync(): Promise<DatosModalInvestigacionBasicos> {
        const modalRef = this.modalService.open(ModalInvestigacionDatosBasicosComponent, { centered: true });

        return await modalRef.result.catch(() => {});
    }

    public async editarInvestigacionAsync(investigacion: InvestigacionDTO): Promise<DatosModalInvestigacionBasicos> {
        const modalRef = this.modalService.open(ModalInvestigacionDatosBasicosComponent, { centered: true });
        const instancia: ModalInvestigacionDatosBasicosComponent = modalRef.componentInstance;

        await instancia.cargarDatosInvestigacionAsync(investigacion);

        return await modalRef.result.catch(() => {});
    }
}
